import { render, staticRenderFns } from "./TcmRxCPD.vue?vue&type=template&id=d243a324&scoped=true"
import script from "./TcmRxCPD.vue?vue&type=script&lang=js"
export * from "./TcmRxCPD.vue?vue&type=script&lang=js"
import style0 from "./TcmRxCPD.vue?vue&type=style&index=0&id=d243a324&scoped=true&lang=css"
import style1 from "./TcmRxCPD.vue?vue&type=style&index=1&id=d243a324&lang=scss&scoped=true"
import style2 from "./TcmRxCPD.vue?vue&type=style&index=2&id=d243a324&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d243a324",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d243a324')) {
      api.createRecord('d243a324', component.options)
    } else {
      api.reload('d243a324', component.options)
    }
    module.hot.accept("./TcmRxCPD.vue?vue&type=template&id=d243a324&scoped=true", function () {
      api.rerender('d243a324', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TCMRx/TcmRxCPD.vue"
export default component.exports